import WalletModule from './views/Module.vue';
import WalletDeposit from './views/WalletDeposit.vue';
import DepositPaymentMethod from './views/DepositPaymentMethod.vue';
import WalletWithdraw from './views/WalletWithdraw.vue';
import Transactions from './views/Transactions.vue';
import TransactionDetails from './views/TransactionDetails.vue';

const WalletRoutes = {
    path: '/',
    component: WalletModule,
    children: [
        {
            path: 'wallet-deposit',
            name: 'wallet-deposit',
            component: WalletDeposit,
        },
        {
            path: 'deposit-payment',
            name: 'deposit-payment',
            component: DepositPaymentMethod,
        },
        {
            path: 'wallet-withdraw',
            name: 'wallet-withdraw',
            component: WalletWithdraw,
        },
        {
            path: 'transactions',
            name: 'Transactions',
            component: Transactions
        },
        {
            path: 'transaction-details/:id',
            name: 'TransactionDetails',
            component: TransactionDetails
        },
    ],
}

export default WalletRoutes;